<template>
  <section class="content-area__content">
    <vue-title :title="$t('identityProvider:logout:title')"></vue-title>
    <h1 class="section-title">
      <span v-if="signedOut" data-test-element="logout-title">{{ $t('identityProvider:logout:title') }}</span>
      <span v-else>{{ $t('identityProvider:logout:confirmTitle') }}</span>
    </h1>
    <div class="validation-summary-errors alert alert-danger fade show" role="alert" data-valmsg-summary="true" data-test-element="idp-alert-danger-generic" v-if="model.showError && !hasAnyFieldErrors">
      <i class="material-icons">warning</i>
      <span>{{ model.errorMessage }}</span>
    </div>
    <div v-if="signedOut" class="panel">
      <div class="panel-message">
        {{ $t('identityProvider:logout:instructions') }}
        <a v-if="model.postLogoutRedirectUri" class="link" :href="model.postLogoutRedirectUri" data-test-element="login-link">{{ $t('identityProvider:logout:loginLink') }}</a>
      </div>
      <iframe width="0" height="0" :src="model.signOutIFrameUrl" v-if="model.signOutIFrameUrl" :title="$t('identityProvider:logout:loginLink')"></iframe>
    </div>
    <div v-else>
      <form ref="form" action="SignOut/Index"></form>
    </div>
  </section>
</template>

<script>
  import redirectHandler from 'utils/redirect';

  export default {
    name: 'Logout',
    data: () => ({
      model: {
        logoutId: null,
        showError: false,
        errorMessage: null,
        postLogoutRedirectUri: null,
        signOutIFrameUrl: null,
        automaticRedirectAfterSignOut: false
      },
      signedOut: false,
      antiforgery: null,
      hasAnyFieldErrors: false
    }),

    methods: {
      async post() {
        const logoutId = this.model.logoutId;
        const form = this.$refs.form;
        try {
          const response = await this.$http.post(form.action, {}, { params: { logoutId } });
          const model = response.data;
          if (model.automaticRedirectAfterSignOut) {
            location.href = redirectHandler.validateURL(model.postLogoutRedirectUri);
          }
          this.model = model;
          this.signedOut = true;
        } catch (error) {
          const resp = error?.response;
          const msg = resp?.data?.message || error?.message;
          if (msg) {
            this.model.showError = true;
            this.model.errorMessage = msg;
          }
          throw error;
        }
      }
    },

    async mounted() {
      const logoutId = this.$route.query['logoutId'];
      const form = this.$refs.form;
      try {
        const response = await this.$http.get(form.action, { params: { logoutId } });

        if (response.status === 200 && response.data && response.data.redirectUrl) {
          const postResponse = await this.$http.post(form.action, {}, { params: { logoutId } });
          const model = postResponse.data;
          if (model.automaticRedirectAfterSignOut) {
            location.href = redirectHandler.validateURL(model.postLogoutRedirectUri);
          }
          this.model = model;
          this.signedOut = true;
        } else {
          this.model = response.data;
        }
      } catch (error) {
        const resp = error?.response;
        const msg = resp?.data?.message || error?.message;
        if (msg) {
          this.model.showError = true;
          this.model.errorMessage = msg;
        }
        throw error;
      }
    }
  };
</script>

<style>
</style>